import React, { useEffect, useRef, useState } from "react";
import PropTypes from 'prop-types';
import { useStoreState, useStoreActions } from 'easy-peasy';
import Loader from "../../widgets/Loader";
import VideoConversionsComponent from "./VideoConversionsComponent";
import VideoMediasComponent from "./VideoMediasComponent";
import { Button, Row } from "react-bootstrap";
import UploadVideoMediaFormComponent from '../UploadVideoMediaFormComponent.jsx';
import { useModal } from '../../../hooks/useModal';
import HelperMetiers360 from '../../../services/HelpersMetiers360';


const VideoMediasAndConversions = (props) => {
    const { video } = props;

    const { isFetchingMediaAndConversionProp } = useStoreState(state => state.videos);
    const { fetchVideoMediasAndConversions } = useStoreActions(actions => actions.videos);

    const { modalComponent, setModalShow, modalData, setModalData } = useModal();

    const uploadFormRef = useRef(null); 

    const [isVideoMediasOpen, setIsVideoMediasOpen] = useState(false);
    const [isConversionsOpen, setIsConversionsOpen] = useState(false);


    useEffect(() => {
        video?.uniqueId && fetchVideoMediasAndConversions({ uniqueId: video.uniqueId });
    }, []);

    const originalMedia = video?.videoMedias?.find(m => m.type == 'original');
    const videoMediaLink = video?.videoMedias?.find(m => m.videoMediaLink)?.videoMediaLink;

    const showOriginalMedia = () => {
        setModalData({
            ...modalData,
            header: <>Fichier video original</>,
            content: <>
                <video width="100%" controls>
                    <source src={originalMedia.url} type={"video/".concat(originalMedia.url.split('.')?.at(-1))} /> Your browser does not support the video tag.
                </video>
                <div className="original-video-file-info">
                    <div><strong>Nom fichier:</strong> {originalMedia.localName}</div>
                    <div><strong>Hash:</strong> {originalMedia.hash}</div>
                    <div><strong>Taille:</strong> {HelperMetiers360.formatBytes(originalMedia.fileSize)}</div>
                </div>
            </>
        });

        setModalShow(true);
    }

    const uploadVideoMedia = () => {
        setModalData({
            ...modalData,
            header: <>Upload d'une experience immersive</>,
            content: <UploadVideoMediaFormComponent video={video} onSuccess={() => { fetchVideoMediasAndConversions({ uniqueId: video.uniqueId }); setModalShow(false) }} ref={uploadFormRef} />,
            cancelButton: 'Annuler',
            onValidate: () => {
                uploadFormRef.current?.submitForm();
            },
            size: 'xl'
        });
        setModalShow(true);
    }

    return (!isFetchingMediaAndConversionProp ?
            <>
                <div className="original-media-section">
                    {originalMedia &&
                        <Button as="a" variant="light" onClick={() => { showOriginalMedia() }}>Voir le fichier video original</Button>
                    }
                {videoMediaLink && !originalMedia &&
                    <Button as="a" variant="light" href={videoMediaLink}>Lien fichier video</Button>
                    }
                    <Button variant="success" onClick={uploadVideoMedia}>
                        <i className="fas fa-upload"></i> &nbsp; Uploader un {originalMedia ? "nouveau " : ""}fichier vidéo
                    </Button>
                </div>


                <Row className="row-midspace">
                    <div className="d-flex justify-content-between me-3 clickable" onClick={() => setIsVideoMediasOpen(!isVideoMediasOpen)}>
                        <div className="d-flex align-items-center">
                            <h4 className="m-0">Medias</h4>
                            <span className="ms-2">( {video?.videoMedias?.length} )</span>
                        </div>
                        {isVideoMediasOpen
                            ? <i className="fa fa-angle-up fa-lg"></i>
                            : <i className="fa fa-angle-down fa-lg"></i>
                        }
                    </div>
                    <Row className={!isVideoMediasOpen ? "d-none" : "row-smallspace"}>
                        {video?.videoMedias && <VideoMediasComponent medias={video?.videoMedias} />}
                    </Row>
                </Row>


                <hr />

                <Row className="row-midspace">
                    <div className="d-flex justify-content-between me-3 clickable" onClick={() => setIsConversionsOpen(!isConversionsOpen)}>
                        <div className="d-flex align-items-center">
                            <h4 className="m-0">Conversions</h4>
                            <span className="ms-2">( {video?.conversions?.length} )</span>
                        </div>
                        {isConversionsOpen
                            ? <i className="fa fa-angle-up fa-lg"></i>
                            : <i className="fa fa-angle-down fa-lg"></i>
                        }
                    </div>
                    <Row className={!isConversionsOpen ? "d-none" : "row-smallspace"}>
                        {video?.conversions && <VideoConversionsComponent conversions={video?.conversions} />}
                    </Row>
                </Row>

                {modalComponent}
            </>
            : <Loader />
    );
}

VideoMediasAndConversions.propTypes = {
    video: PropTypes.object.isRequired
}

export default VideoMediasAndConversions;